import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as charactersApi from '../api/characters';

export const useCharacters = (gameId, params = {}) => {
  return useQuery({
    queryKey: ['characters', gameId, params],
    queryFn: () => charactersApi.getCharacters(gameId, params),
    enabled: !!gameId,
  });
};

export const useCharacter = (gameId, characterId) => {
  return useQuery({
    queryKey: ['character', gameId, characterId],
    queryFn: () => charactersApi.getCharacter(gameId, characterId),
    enabled: !!gameId && !!characterId,
  });
};

export const useCreateCharacter = (gameId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (characterData) => charactersApi.createCharacter(gameId, characterData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['characters', gameId] });
      queryClient.invalidateQueries({ queryKey: ['gameState', gameId] });
    },
  });
};

export const useUpdateCharacter = (gameId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ characterId, ...characterData }) => charactersApi.updateCharacter(gameId, characterId, characterData),
    onSuccess: (_, { characterId }) => {
      queryClient.invalidateQueries({ queryKey: ['character', gameId, characterId] });
      queryClient.invalidateQueries({ queryKey: ['characters', gameId] });
      queryClient.invalidateQueries({ queryKey: ['gameState', gameId] });
    },
  });
};

export const useDeleteCharacter = (gameId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (characterId) => charactersApi.deleteCharacter(gameId, characterId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['characters', gameId] });
      queryClient.invalidateQueries({ queryKey: ['gameState', gameId] });
    },
  });
};

export const useAddCharacterAspect = (gameId, characterId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (aspectData) => charactersApi.addCharacterAspect(gameId, characterId, aspectData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['character', gameId, characterId] });
      queryClient.invalidateQueries({ queryKey: ['characters', gameId] });
    },
  });
};

export const useRemoveCharacterAspect = (gameId, characterId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (aspectIndex) => charactersApi.removeCharacterAspect(gameId, characterId, aspectIndex),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['character', gameId, characterId] });
      queryClient.invalidateQueries({ queryKey: ['characters', gameId] });
    },
  });
};

export const useAddCharacterToScene = (gameId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ sceneId, characterId }) => charactersApi.addCharacterToScene(gameId, sceneId, characterId),
    onSuccess: (_, { sceneId }) => {
      queryClient.invalidateQueries({ queryKey: ['scene', gameId, sceneId] });
      queryClient.invalidateQueries({ queryKey: ['scenes', gameId] });
    },
  });
};

export const useRemoveCharacterFromScene = (gameId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ sceneId, characterId }) => charactersApi.removeCharacterFromScene(gameId, sceneId, characterId),
    onSuccess: (_, { sceneId }) => {
      queryClient.invalidateQueries({ queryKey: ['scene', gameId, sceneId] });
      queryClient.invalidateQueries({ queryKey: ['scenes', gameId] });
    },
  });
};
